<template>
	<div>
		<el-dialog title="修改资料" width="700px" :visible.sync="$store.state.user.updateInfoFlag"
			:close-on-click-modal="false">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-row>
					<el-col :span="12">
						<el-form-item label="手机号">
							<el-input v-model="ruleForm.phonenumber"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="姓名" prop="nickName">
							<el-input v-model="ruleForm.nickName"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="所在地区">
							<el-cascader
								v-model="value"
								:options="options"
								style="width: 100%;"
								:props="props">
								<template slot-scope="{ node, data }">
									<span>{{ data.name }}</span>
								</template>
							</el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="性别" prop="sex">
							<el-select v-model="ruleForm.sex" style="width: 100%;">
								<el-option v-for="item, i in sexList" :label="item.dictLabel" :value="item.dictValue"
									:key="i"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="就读中学">
							<el-input v-model="ruleForm.schoolName"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="所在班级">
							<el-input v-model="ruleForm.className"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="高考省份" prop="enrollProvinceId">
							<el-select v-model="ruleForm.enrollProvinceId" style="width: 100%;">
								<el-option v-for="item, i in proviceList" :label="item.dictLabel" :value="item.dictValue"
									:key="i"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="高考年份" prop="enrollYear">
							<el-select v-model="ruleForm.enrollYear" style="width: 100%;">
								<el-option v-for="item, i in yearList" :label="item" :value="item" :key="i"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					
				</el-row>
				<el-row>
					<el-form-item label="考试类型">
						<el-radio-group v-model="ruleForm.examType">
							<el-radio v-for="item, i in examTypeList" :label="item.dictValue" :key="i">{{
								item.dictLabel }}</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-row>
				<el-row>
					<el-form-item label="高考科目">
						<el-checkbox-group v-model="checkList" :min="1" :max="3">
							<el-checkbox v-for="item, i in selectTypeList" :label="item.dictValue" :key="i">{{
								item.dictLabel }}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="高考总分">
							<el-input v-model="ruleForm.score" type="number" @input="scoreChange">
								<i slot="suffix">
									分
								</i>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="排名位次">
							<el-input v-model="ruleForm.rankNo"><i slot="suffix">
									位
								</i></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click='$store.commit("UPDATE_UPDATEINFOFLAG", false)'>取 消</el-button>
				<el-button type="primary" @click="save" style="margin-left: 20px !important;">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { updateStudent, currentStudent, updateScore,getProvinceInfo,getSupportProvince } from '@/api/login'
import { dictList } from '@/api/college'
export default {
	name: "update-info",
	data() {
		return {
			checkList: [],
			ruleForm: {
				"studentId": null,
				"userId": "",
				"enrollProvinceId": "",
				"enrollProvinceName": "",
				"enrollYear": "",
				"schoolName": "",
				"score": null,
				"rankNo": null,
				"selectSubject": "",
				"selectSubjectList": [],
				"nickName": "",
				"sex": "",
				"avatar": "",
				"phonenumber": ""
			},
			props: {
				lazy: true,
				lazyLoad :this.loadTreeNode
			},
			examTypeList: [],
			rules: {
				nickName: [
					{ required: true, message: '请输入姓名', trigger: 'blur' }
				],
				enrollProvinceId: [
					{ required: true, message: '请选择高考省份', trigger: 'change' }
				],
				enrollYear: [
					{ required: true, message: '请选择高考年份', trigger: 'change' }
				],
				sex: [
					{ required: true, message: '请选择性别', trigger: 'change' }
				]
			},
			value:'',
			options:[],
			sexList: [],
			proviceList: [],
			selectTypeList: [],
			level:1,
			yearList: [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030]

		}
	},
	created() {
		this.getDic();
		this.getStuInfo();
	},
	methods: {
		//加载树节点  首次加载页面时就会执行一次，之后每选中一个节点也会调用，来渲染下一层
    async loadTreeNode(node, resolve) {
			console.log(node, resolve)
      // 首次加载时 node为{root:true,level:0}
      // node 节点数据  获取node的level字段的值
      const { level } = node;
      //下一层节点
      const nodes = [];
      //如果有子节点 或者 为根节点（即首次进入level为0）
      //也有人写成 node.level == 0 作用是一样的
      if (node.hasChildren || node.root) {
        // 0 代表第一次请求
        let nodeId = level == 0 ? "" : node.data.id;
        //这里setTimeout的目的是 显示加载动画
        setTimeout(() => {
          let params = {
            level:level+1,
						parentId:node.data?node.data.id:''
          };
          getProvinceInfo(params).then((res) => {
            if (res && res.code == 200) {
              let nodes = [];
              nodes = res.rows;
              nodes.map((val) => {　　　　　　　　　　//对后台数据进行一下处理，转成规定的label和value
                val.label = val.name;
                val.value = val.id;
								val.leaf = level>=2
              });
              // 回调渲染下一层
              resolve(nodes);
            }
          });
        }, 1);
      } else {
        //如果没有子节点就不发起请求，直接渲染，也避免了点击叶子节点仍然有加载动画的问题
        resolve(nodes);
      }
    },
		async getProvince() {
			let res = await getProvinceInfo({
				level:this.level
			});
			if (res && res && res.code == 200) {
				if(this.level==1){
					this.options = res.rows
				}
			}
		},
		async getStuInfo() {
			let res = await currentStudent();
			if (res && res && res.code == 200) {
				this.ruleForm = res.data
				this.checkList = res.data.selectSubjectList==""?[]:res.data.selectSubjectList
				this.$store.commit("UPDATE_STUDENT", res.data)
			}
		},
		scoreChange() {
			let provinceInfo = this.proviceList.find(item => this.ruleForm.enrollProvinceId == item.dictValue)
			updateScore({
				year: this.ruleForm.enrollYear,
				clazz: '综合',
				provinceNames: provinceInfo.dictLabel,
				score: this.ruleForm.score
			}).then(res => {
				console.log(res)
				if (res && res.code == 200) {
					this.$message({
						message: '修改成功',
						type: 'success'
					});
					this.ruleForm.rankNo = res.data
				}
			})
		},
		async save() {
			this.$refs["ruleForm"].validate((valid) => {
				if (valid) {
					this.ruleForm.selectSubjectList = this.checkList
					this.ruleForm.selectSubject = this.checkList.join(',')
					updateStudent(this.ruleForm).then(res => {
						if (res && res.code == 200) {
							this.$message({
								message: '修改成功',
								type: 'success'
							});
							this.$store.commit("UPDATE_UPDATEINFOFLAG", false);
							this.updateStu();
						}
					})
				}
			})
		},
		async updateStu() {
			//获取用户信息
			let user = await currentStudent();
			this.$store.commit("UPDATE_STUDENT", user.data)
		},
		async getDic() {
			//select_subject_type 选课科目字典 sys_user_sex 用户性别字典 province_type 高考地区字典
			let resSex = await dictList("sys_user_sex");
			this.sexList = resSex.data;
			let resSubjectType = await dictList("select_subject_type");
			this.selectTypeList = resSubjectType.data;
			let resProvice = await getSupportProvince();
			this.proviceList = resProvice.data;
			let resExamTypeList = await dictList("exam_type")
			this.examTypeList = resExamTypeList.data
		}

	}
}
</script>

<style lang="less">
/* 隐藏 el-cascader 最后一层选项的箭头 */
.el-cascader-panel .el-scrollbar__bar {
  display: none;
}
</style>